import SliderEmpreendimento from '../components/SliderEmpreendimento';
import ModalVideo from '../components/ModalVideo';
import BackgroundVideoPlayerHome from '../components/BackgroundVideoPlayerHome';
import RegionsTab from '../components/RegionsTab';
import HomeBannersSlider from '../components/HomeBannersSlider';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    HomeBannersSlider.init();
    RegionsTab.init();
    SliderEmpreendimento.init();
    ModalVideo.init({
      onInitiated: BackgroundVideoPlayerHome.init(),
      onOpen: BackgroundVideoPlayerHome.pause(),
      onClose: BackgroundVideoPlayerHome.play(),
    });
  },
};
